export default "__VITE_ASSET__DKBxPhCL__"